const defaultState = {
    personalData: {},
    personalSlots: [],
    slots: [],
    personalSlotsNext: [],
    nextSlots: [],
}

const SET_PERSONAL_DATA = "SET_PERSONAL_DATA"
const SET_PERSONAL_SLOTS = "SET_PERSONAL_SLOTS"
const SET_SLOTS = "SET_SLOTS"
const SET_PERSONAL_SLOTS_NEXT = "SET_PERSONAL_SLOTS_NEXT"
const SET_NEXT_SLOTS = "SET_NEXT_SLOTS"

export const personalScheduleReducer = (state = defaultState, action) => {
    switch (action.type) {
        case SET_PERSONAL_DATA:
            return { ...state, personalData: action.payload }
        case SET_PERSONAL_SLOTS:
            return { ...state, personalSlots: action.payload }
        case SET_SLOTS:
            return { ...state, personalSlots: action.payload }
        case SET_NEXT_SLOTS:
            return { ...state, nextSlots: action.payload }
        case SET_PERSONAL_SLOTS_NEXT:
            return { ...state, personalSlotsNext: action.payload }

        default:
            return state
    }
}

export const setPersonalDataAction = (payload) => ({ type: SET_PERSONAL_DATA, payload })
export const setPersonalSlotsAction = (payload) => ({ type: SET_PERSONAL_SLOTS, payload })
export const setPersonalSlotsNextAction = (payload) => ({ type: SET_PERSONAL_SLOTS_NEXT, payload })
export const setSlotsAction = (payload) => ({ type: SET_SLOTS, payload })
export const setNextSlotsAction = (payload) => ({ type: SET_NEXT_SLOTS, payload })